import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BasicList from './BasicList';
import ClientProvider from './client';
export default createDemo(import.meta.url, BasicList, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/lists/demos/basic/BasicList.tsx",
    "fileName": "BasicList.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport Divider from '@mui/material/Divider';\nimport InboxIcon from '@mui/icons-material/Inbox';\nimport DraftsIcon from '@mui/icons-material/Drafts';\n\nexport default function BasicList() {\n  return (\n    <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <nav aria-label=\"main mailbox folders\">\n        <List>\n          <ListItem disablePadding>\n            <ListItemButton>\n              <ListItemIcon>\n                <InboxIcon />\n              </ListItemIcon>\n              <ListItemText primary=\"Inbox\" />\n            </ListItemButton>\n          </ListItem>\n          <ListItem disablePadding>\n            <ListItemButton>\n              <ListItemIcon>\n                <DraftsIcon />\n              </ListItemIcon>\n              <ListItemText primary=\"Drafts\" />\n            </ListItemButton>\n          </ListItem>\n        </List>\n      </nav>\n      <Divider />\n      <nav aria-label=\"secondary mailbox folders\">\n        <List>\n          <ListItem disablePadding>\n            <ListItemButton>\n              <ListItemText primary=\"Trash\" />\n            </ListItemButton>\n          </ListItem>\n          <ListItem disablePadding>\n            <ListItemButton component=\"a\" href=\"#simple-list\">\n              <ListItemText primary=\"Spam\" />\n            </ListItemButton>\n          </ListItem>\n        </List>\n      </nav>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 51,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport Divider from '@mui/material/Divider';\nimport InboxIcon from '@mui/icons-material/Inbox';\nimport DraftsIcon from '@mui/icons-material/Drafts';\n\nexport default function BasicList() {\n  return (\n    <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <nav aria-label=\"main mailbox folders\">\n        <List>\n          <ListItem disablePadding>\n            <ListItemButton>\n              <ListItemIcon>\n                <InboxIcon />\n              </ListItemIcon>\n              <ListItemText primary=\"Inbox\" />\n            </ListItemButton>\n          </ListItem>\n          <ListItem disablePadding>\n            <ListItemButton>\n              <ListItemIcon>\n                <DraftsIcon />\n              </ListItemIcon>\n              <ListItemText primary=\"Drafts\" />\n            </ListItemButton>\n          </ListItem>\n        </List>\n      </nav>\n      <Divider />\n      <nav aria-label=\"secondary mailbox folders\">\n        <List>\n          <ListItem disablePadding>\n            <ListItemButton>\n              <ListItemText primary=\"Trash\" />\n            </ListItemButton>\n          </ListItem>\n          <ListItem disablePadding>\n            <ListItemButton component=\"a\" href=\"#simple-list\">\n              <ListItemText primary=\"Spam\" />\n            </ListItemButton>\n          </ListItem>\n        </List>\n      </nav>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 51,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/List",
      "@mui/material/ListItem",
      "@mui/material/ListItemButton",
      "@mui/material/ListItemIcon",
      "@mui/material/ListItemText",
      "@mui/material/Divider",
      "@mui/icons-material/Inbox",
      "@mui/icons-material/Drafts"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
